/**
 * Practitioner-id guard for the phone-call note save.
 *
 * The backend `CreateUpdatePhoneCallNotes` DTO's `PractitionerId` is a
 * non-nullable Guid. An empty string or the all-zero Guid deserialises to
 * `Guid.Empty` and 400s (or throws). The dashboard resolves the id from the
 * auth user via a fallback chain that can come up empty; this guard lets the
 * panel disable the save instead of POSTing an unusable Guid.
 */
const ZERO_GUID = '00000000-0000-0000-0000-000000000000';

/** True when `id` is a usable practitioner Guid (non-blank, not the zero Guid). */
export function isUsablePractitionerId(id: string | undefined | null): id is string {
  return typeof id === 'string' && id.trim() !== '' && id !== ZERO_GUID;
}
